import { render, staticRenderFns } from "./manufacturerOverviewComponent.vue?vue&type=template&id=b73b7bc4&scoped=true"
import script from "./manufacturerOverviewComponent.vue?vue&type=script&lang=js"
export * from "./manufacturerOverviewComponent.vue?vue&type=script&lang=js"
import style0 from "./manufacturerOverviewComponent.vue?vue&type=style&index=0&id=b73b7bc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73b7bc4",
  null
  
)

export default component.exports